import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2022-02-17T11:00",
		title: `
<p class="paragraph-indent">
●新潟県在宅医療推進センター実践報告会の開催について<br>
<em>参加対象：</em>在宅医療推進センター職員、在宅医療・介護連携推進事業担当者等<br>
・<a href="${topicsDir}/2022/02-practice-briefing.pdf">開催案内/参加申込書</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
